import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { APP_SETTINGS } from '../../shared/models/backofficeConfiguration';
import { UserNewsletterSite } from '../model/UserNewsletterSite';
import { ExecuteService } from '../../shared/services/executeService.service';
import { ErrorHandlerService } from '../../shared/services/errorHandler.service';
import { NewsletterTypesService } from './newsletterTypes.service';
import { NewsletterType } from '../model/NewsletterType';
import { CustomEncoder } from '../../shared/services/url.service';

@Injectable()
export class UserNewslettersService {
  private userNewsletterApiURL = APP_SETTINGS.UserNewsletterApiUrl;

  constructor(
    private executeService: ExecuteService,
    private newsletterTypesService: NewsletterTypesService,
    private errorHandler: ErrorHandlerService) {
  }

  public GetUserNewslettersByEmail(email: string): Observable<UserNewsletterSite[]> {
    const url: string = this.userNewsletterApiURL;
    const params = new HttpParams({ encoder: new CustomEncoder() }).set('email', email);

    return Observable.forkJoin([
      this.executeService.ExecuteWithToken('get', url, params),
      this.newsletterTypesService.GetNewsletterTypes()
    ])
      .pipe(
        map(([userNewsletters, newsletterTypes]) => this.mapUserNewslettersModels(userNewsletters, newsletterTypes)),
        catchError(this.errorHandler.handleError<object[]>('UserNewslettersService_GetUserNewslettersByEmail email', [], true))
      );
  }

  public Delete(email: string) {
    const url = `${this.userNewsletterApiURL}/${email}`;
    return this.executeService.ExecuteWithToken('delete', url)
      .pipe(
        catchError(this.errorHandler.handleAndThrowError('UserNewsletterService_Delete', null, true))
      );
  }

  private mapUserNewslettersModels(userNewsletters: any, types: NewsletterType[]): any {
    let response: UserNewsletterSite[] = [];
    if (userNewsletters != null) {
      response = userNewsletters.map(un => {
        const newsletter = types.find(type => type.NewsletterId === un.newsletterId);
        return {
          UserNewsletterId: un.id,
          Status: un.status,
          Email: un.email,
          NewsletterId: un.newsletterId,
          NewsletterName: newsletter ? newsletter.Name : null,
          CountryCode: un.countryCode
        };
      });
    }
    return response;
  }
}



// WEBPACK FOOTER //
// ./src/app/users/services/userNewsletters.service.ts